<template>
<div class="quiz-answers-summary">
    <div class="quiz-answers-summary__background">
        <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
    </div>
    <div class="quiz-answers-summary__background-yellow kasanowa-desktop">
        <img src="~@/assets/images/yellow-elipse.png" alt="kasanowa" />
    </div>
    <KLayoutWrapper>
        <template #default>
            <div v-if="null != quizInfo && null != userAnswers && null != quizSubmitResponse" class="quiz-answers-summary__wrapper">
                <div class="quiz-answers-summary__counter-wrapper">{{ $t('quiz.yourScoreIs') }} {{ quizSubmitResponse.correctAnswersCount }} / {{ quizInfo.questions.length }}</div>
                <div v-if="quizSubmitResponse.correctAnswersCount >= quizSubmitResponse.requiredCorrectAnswers || quizInfo.is_questionnaire" class="quiz-answers-summary__money-text">{{ $t('quiz.youEarned') }} {{ quizInfo.value }} PLN {{ $t('quiz.isWasWorthRight') }}</div>
                <div v-else class="quiz-answers-summary__money-text quiz-answers-summary__money-text--red">
                    <div>{{ $t('quiz.youNotEarned') }} {{ quizInfo.value }} PLN {{ $t('quiz.money') }}</div>
                    <div v-if="quizSubmitResponse.correctAnswersCount < quizSubmitResponse.requiredCorrectAnswers && !quizInfo.is_one_time" class="quiz-answers-summary__description">{{ $t('quiz.replyQuiz') }}</div>
                </div>
                <div class="quiz-answers-summary__btn-wrapper">
                    <KButton
                        id="back-to-dashboard"
                        normal
                        :label="$t('quiz.back')"
                        @click="navigateTo('/dashboard')"
                    />
                    <KButton
                        v-if="quizSubmitResponse.correctAnswersCount < quizSubmitResponse.requiredCorrectAnswers && !quizInfo.is_one_time"
                        id="reply-quiz"
                        normal
                        secondary
                        :label="$t('quiz.replyBtnQuiz')"
                        @click="navigateTo(`/quiz-ph/${quizInfo.id}`)"
                    />
                </div>
            </div>
        </template>
    </KLayoutWrapper>
</div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useQuizStore } from '@/stores/quiz';
import { navigateTo, navigateToWithErrorToast } from '@/hooks/NavigateHooks';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import KButton from '@/components/atoms/KButton.vue';

const { quizInfo, userAnswers, quizSubmitResponse } = storeToRefs(useQuizStore());
// if (userAnswers.value == null || quizSubmitResponse.value == null) {
//     navigateToWithErrorToast('/dashboard', t('quiz.toast.errorQuizSummary'));
// }
</script>

<style scoped lang="scss">
.quiz-answers-summary {
    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__background-yellow {
        position: absolute;
        top: -30px;
        left: -40%;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            width: max-content;
            height: 100vh;
        }
    }

    &__wrapper {
        position: relative;
        background: rgba($white, 0.15);
        backdrop-filter: blur(30px) saturate(150%);
        -webkit-backdrop-filter: blur(30px) saturate(150%);
        border-radius: 5px;
        border: 1px solid $secondary-400;
        padding: 15px;
        max-width: 1025px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;

        @include media-breakpoint-up(lg) {
            padding: 52px;
            margin: 50px auto 0;
        }
    }

    &__counter-wrapper {
        font-size: 24px;
        color: $white;
        font-weight: 700;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    &__money-text {
        font-size: 20px;
        color: $green-400;
        font-weight: 700;

        &--red {
            color: $red-400;
        }
    }

    &__description {
        font-size: 16px;
        color: $white;
        font-weight: 500;
        text-align: center;
    }

    &__btn-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 10px;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
            justify-content: center;
            gap: 40px;
        }
    }
}
</style>
